var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueMarkdown',{staticClass:"overflow-x-auto",attrs:{"source":_vm.source,"toc":"","toc-anchor-link-symbol":""},on:{"rendered":_vm.jumpToHash}})}
var staticRenderFns = []

export { render, staticRenderFns }